import { useEffect, useState } from 'react';
import { useT } from '../i18n/i18n';
import { LAUNCH_MS, takeLaunchAnimation } from './launch';

// App launch motion (Figma page 07 "App Launch Motion"): the house outline draws, a scan sweeps it,
// the check lands, the product name appears — then it is gone. Rules from the frame annotations and
// the Owner (2026-09-11):
//   · cold start ONLY — main.tsx arms it once per page load; coming back from the background never
//     replays it, and it is never armed for the development scenarios or the gallery
//   · it never delays the app: the real screen is already mounted behind it and this is an overlay
//   · a tap anywhere skips it, and "reduce motion" skips the motion entirely
//   · it lands on whatever the app resolved to (首页 when signed in, sign-in otherwise)
export function LaunchOverlay() {
  const { t } = useT();
  const [playing, setPlaying] = useState(takeLaunchAnimation);

  useEffect(() => {
    if (!playing) return;
    const timer = window.setTimeout(() => setPlaying(false), LAUNCH_MS);
    return () => window.clearTimeout(timer);
  }, [playing]);

  if (!playing) return null;
  return (
    <div className="launch" onClick={() => setPlaying(false)} data-testid="launch-overlay">
      <svg className="launch-mark" viewBox="0 0 96 96" aria-hidden="true">
        <path className="launch-house" d="M10 46 L48 14 L86 46" />
        <path className="launch-walls" d="M20 40 V84 H76 V40" />
        <path className="launch-check" d="M33 60 L44 71 L67 46" />
        <line className="launch-scan" x1="16" y1="30" x2="80" y2="30" />
      </svg>
      <p className="launch-brand">{t('shell.productName')}</p>
      <p className="launch-tagline">{t('launch.tagline')}</p>
      <button type="button" className="launch-skip" onClick={() => setPlaying(false)} data-testid="launch-skip">
        {t('launch.skip')}
      </button>
    </div>
  );
}
